export class PublicBoxQuestionnaireContextOperations {
  public constructor(
    private readonly data: {
      canBeViewed: boolean;
      canBeFilled: boolean;
    },
  ) {}

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeFilled(): boolean {
    return this.data.canBeFilled;
  }
}
